// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialIconLink_container__1AViU","icon":"SocialIconLink_icon__8jd_8","smallIcon":"SocialIconLink_smallIcon__31ykW","sending":"SocialIconLink_sending__1zW6Z"};